import * as React from 'react';
import type { CardsSectionProps } from '~/Features/Partials/CardsSection/CardsSection';
import { CardsSection } from '~/Features/Partials/CardsSection/CardsSection';
import type { StrictOmit } from '~/Partials/Utils/typeUtils';
import styles from './ApplicationProcessSection.module.css';

export interface ApplicationProcessSectionProps extends StrictOmit<CardsSectionProps, 'colorVariant' | 'className'> {
    id: string;
}

export const ApplicationProcessSection: React.FC<ApplicationProcessSectionProps> = props => (
    <CardsSection {...props} colorVariant="light" className={styles.ApplicationProcessSection} />
);
